import { accountPath } from '@collab/libs/auth/authPaths';
import { removeTrailingSlashes } from '@collab/utils/getValidRedirectUrl';

const protectedUrls = removeTrailingSlashes([accountPath]);

export default protectedUrls;
